import React from "react";
import {
  Paper,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableRow,
  Typography,
  Box,
  Divider,
} from "@mui/material";

const PreviewTableTermination = ({ rows = [] }) => {
  if (!rows.length) return null;

  return (
    <TableContainer
      component={Paper}
      sx={{
        mt: 2,
        borderRadius: 2,
        overflow: "hidden",
        boxShadow: "0px 2px 6px rgba(0,0,0,0.08)",
      }}
    >
      <Table size="small">
        <TableBody>


          {/* --- Header γραμμή (μία φορά ανά τύπο) --- */}
          <TableRow>
            <TableCell sx={{ width: "40%", fontWeight: 600 }}>
              Τρέχουσα Κατάσταση
            </TableCell>
            <TableCell align="right" sx={{ width: "15%", fontWeight: 600 }}>
              Πλήθος
            </TableCell>

            <TableCell sx={{ width: "45%", fontWeight: 600 }}>
              Επόμενη Κατάσταση
            </TableCell>
          </TableRow>

          {/* --- Περιεχόμενο --- */}
          {rows.map((row, sIdx) => (
            <TableRow key={sIdx}>
              <TableCell>{row.status}</TableCell>
              <TableCell align='right'>{row.count}</TableCell>
              <TableCell>{row.nextStatus}</TableCell>
            </TableRow>
          ))}

          {/* --- Divider ανά τύπο --- */}
          <TableRow>
            <TableCell colSpan={3} sx={{ p: 0 }}>
              <Divider />
            </TableCell>
          </TableRow>

        </TableBody>
      </Table>
    </TableContainer>
  );
};

export default PreviewTableTermination;
